export const truncateText = (ctx: CanvasRenderingContext2D, text: string, maxWidth: number) => {
	if (!text) return "-";

	let truncatedText = text;
	let textWidth = ctx.measureText(truncatedText).width;

	while (textWidth > maxWidth && truncatedText.length > 0) {
		truncatedText = truncatedText.substring(0, truncatedText.length - 1).trim();
		textWidth = ctx.measureText(truncatedText + "...").width;
	}

	return truncatedText + (truncatedText !== text ? "..." : "");
};

// This function iterates through the thresholds and steps to find the appropriate step size for the range of numbers and calculates the minimum and maximum values based on the step size.
// If the range of numbers exceeds all thresholds, the function uses the last step size to calculate the minimum and maximum values.
export const inferMinMax = (min: number, max: number) => {
	if (min === max) {
		return [parseFloat((min - 1).toFixed(2)), parseFloat((max + 1).toFixed(2))];
	}

	if (typeof min !== "number" || typeof max !== "number") {
		return [0, 100];
	}

	const thresholds = [0.1, 1, 10, 100, 1000, 10000, 100000, 1000000];
	const steps = [0.01, 0.1, 1, 10, 100, 100, 100, 10000]; // step sizes for each threshold

	for (let i = 0; i <= thresholds.length; i++) {
		if (Math.abs(max - min) < thresholds[i]) {
			let derivedMin = Math.floor(min / steps[i]) * steps[i];
			let derivedMax = Math.ceil(max / steps[i]) * steps[i];
			if (Math.abs(min - derivedMin) < steps[i - 1]) {
				derivedMin = derivedMin - steps[i];
			}
			if (Math.abs(max - derivedMax) < steps[i - 1]) {
				derivedMax = derivedMax + steps[i];
			}
			return [parseFloat(derivedMin.toFixed(2)), parseFloat(derivedMax.toFixed(2))];
		}
	}
	// If a exceeds all thresholds, use the last step size
	const lastStep = steps[steps.length - 1];
	const derivedMin = Math.floor(min / lastStep) * lastStep;
	const derivedMax = Math.ceil(max / lastStep) * lastStep;
	return [parseFloat(derivedMin.toFixed(2)), parseFloat(derivedMax.toFixed(2))];
};

/**
 * Determine if there is enough room below the reference element to display the options below it.
 * Only needed if options will be displayed closer to the bottom of the page, as in the case of
 * 9-box and scatter charts.
 */
export const hasEnoughRoomBelowForElements = (ref: HTMLDivElement | null, options: any[], size = 24) => {
	const optionHeight = size;
	const optionsHeight = options.length * optionHeight;
	if (!ref) {
		return false;
	}
	const { bottom } = ref.getBoundingClientRect();
	const windowHeight = window.innerHeight;
	const spaceBelow = windowHeight - bottom;
	return spaceBelow > optionsHeight;
};
